// PaaS Login API
export async function loginPaaS({ phone, password, code, inviteCode }) {
  const res = await fetch('/api/login-paas', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ phone, password, code, inviteCode }),
  });
  const data = await res.json().catch(() => ({ code: 3003, msg: 'parse error', data: {} }));
  // Expect shape: { code, msg, data: { token } }
  return { ok: res.ok && data?.code === 0, code: data?.code, msg: data?.msg, token: data?.data?.token };
}

// Send SMS verification code
export async function sendSMS(phone) {
  const res = await fetch('/api/auth/send_sms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone }),
  });
  const data = await res.json().catch(() => ({ code: 3003, msg: 'parse error', data: {} }));
  return { ok: res.ok && data?.code === 0, code: data?.code, msg: data?.msg };
}

// Logout API
export async function logout() {
  try {
    const res = await fetch('/api/logout', {
      method: 'POST',
      credentials: 'include',
    });
    return res.ok;
  } catch (error) {
    console.error('Logout error:', error);
    return false;
  }
}

// Check authentication status
export async function checkAuth() {
  try {
    const res = await fetch('/api/billing/benefits', {
      method: 'GET',
      credentials: 'include',
    });
    
    if (res.ok) {
      const data = await res.json();
      return data.code === 0;
    }
    return false;
  } catch (error) {
    console.error('Auth check error:', error);
    return false;
  }
}

// Get user phone from cookie
export function getUserPhone() {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; user_phone=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

